import { JFSRequest, executeRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  console.log('response=', response)
  const data = isSuccessResponse(response)
  return data
}

const uploadInteractionHistoryFileApi = async (requestBody: any, abortController?: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.uploadInteractionHistoryFileApi),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens, abortController),
    headers: {
      ...getHeaders(),
      'Content-Type': 'multipart/form-data',
    },
    body: requestBody,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error?.data?.message ? error?.data : error
    })
}

export const getUploadInteractionFileReq = (
  file: any,
  mid: any,
  requestId: any,
  name: any,
  merchantDocumentType: any,
) => {
  const data = new FormData()
  data.append('file', file)
  data.append('mid', mid)
  data.append('requestId', requestId)
  data.append('name', name)
  data.append('merchantDocumentType', merchantDocumentType)
  return data
}

export { uploadInteractionHistoryFileApi }
